'use client'

import { clientPage } from '../../../_lib/clientPage'

export default clientPage(() =>
  import('@/components/views/circles/CirclesDiscoverView').then((m) => ({
    default: m.CirclesDiscoverView,
  }))
)
